import { render, staticRenderFns } from "./UpgradeSuccessForm.vue?vue&type=template&id=3a1953ca&scoped=true&"
import script from "./UpgradeSuccessForm.vue?vue&type=script&lang=js&"
export * from "./UpgradeSuccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1953ca",
  null
  
)

export default component.exports